export default __webpack_public_path__ + "static/media/SteelsTableImg1.5937b219.jpg";